
<!-- Tab panes -->
<div class="card pestanas">
  <div class="card-header">
    <div id="menu">
      <ul class="nav">
        <li class="first nav-item">
          <a class="nav-link autorizaciones_element_to_target" [class.active]="isLinkActive('clientadhesions')" (click)="onClientAdhesionsTabClicked()"><span class="d-none d-md-block" translate>cli.tabs.clientAdhesions</span><span class="d-block d-md-none" translate>cli.tabs.shortClientAdhesions</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link receptores_element_to_target" [class.active]="isLinkActive('receivers')" (click)="onReceiversTabClicked()"><span translate>cli.tabs.receivers</span></a>
        </li>
      </ul>
    </div>
  </div>


  <div class="card-body">
    <div class="tab-content" id="myTabContent">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-manager/client/cli-tabs/cli-tabs.component.html